<!-- PAGE LOADER -->
<div class="page-progress">
  <mat-progress-bar mode="indeterminate" *ngIf="moduleLoading"></mat-progress-bar>
</div>

<div class="content-grid">
  <div class="app-hub-content">
    <div class="app-sidebar-container" [ngClass]="{'full-width': !navService.sidebarState.sidenavOpen}">
      <!-- Sidebar -->
      <div class="app-sidebar-wrap">
        <app-sidebar class="sidebar-wrapper"></app-sidebar>
      </div>
      <!-- Content page -->
      <div class="app-content-wrap">
        <!-- Header -->
        <app-header></app-header>
        <div class="app--body-container">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
